export default __webpack_public_path__ + "static/Handsome-Regular-cd498e5bd8591e6c58c9643a3313cb42.woff2";